import React from 'react';
import WName from '../../WName';
import PL from '../../problems/ProblemLink';
import QL from '../../faq/QuestionLink';
import LRL from '../../longreads/LongReadLink';
import AL from '../../angles/AngleLink';
import NW from '../../neologisms/NewWord';
import OML from '../OrMaybeLink';
import {Qual} from '../../common';

// Imagining Heaven and Hell:
//  not WHO you're with,
//  but in what CONTEXT consciousness is interconnected
export const heaven1 = {
  name: "heaven1",
  // 'prelude' will always be 'Or maybe…'
  header: <span>
    What if we imagined Heaven and Hell?
  </span>,
  outside: <span>
    The literal <OML>afterlife</OML>. The <AL name="con">persistence</AL> of the <PL>individual</PL> (as a ‘<OML>Soul</OML><sup>™</sup>’). Let’s <LRL>imagine</LRL> it: no <NW>anfantasia</NW>, and not <PL name="con">entrenched</PL> in <QL name="pratty.">Atomland</QL>’s <PL name="foe.">worshipped</PL> <NW>conservative thinking</NW> (<NW>atomocentrism</NW>). Let’s <LRL>imagine</LRL> it <WName ically />.
  </span>,
  preview: <div className="or-maybe-preview">
    <p><PL name="ch.">Amit</PL> came out to where <QL name="reader.">jeetjet</QL> and <QL name="reader.jung4">融 (jung)</QL> were ‘sitting’ – because <i><PL>you are your body</PL></i>: for jeetjet 110% (even in the ‘<OML>afterlife</OML>’) and 融 (jung) may be melting, but it was unlikely 融 (jung) was able to catch the <PL>SEB ION</PL> in a flash whenever that one reared its (ugle) face.<sup>†</sup>
</p>
    <p>Under construction</p>
  </div>, 

// It's not about WHO you're with, but the gnostic configuration of God.. which is consciousness.
    topFootnote: <span>† Face = ‘you’ because <i><PL>you are your body</PL></i></span>
/*  text: <div className="or-maybe-text">
  </div>, */
};

